import { render, staticRenderFns } from "./AdvancedCoreHeader.vue?vue&type=template&id=65685ae8&scoped=true&"
import script from "./AdvancedCoreHeader.vue?vue&type=script&lang=js&"
export * from "./AdvancedCoreHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65685ae8",
  null
  
)

export default component.exports